import React from 'react';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';
import Modal from '../../../../Components/Modal/Modal';
import PatientInsuranceSetupVerify from './PatientInsuranceSetupVerify';
import NCZIPatient from '../NCZIPatient/NCZIPatient';

interface Props {
	opened: boolean;
	patientId: string;
	onClose: (needReload: boolean) => void;
}

const PatientInsuranceSetupVerifyModal: React.FC<Props> = props => {
	const { opened, onClose, patientId } = props;
	const { isCase } = useTreatmentContext();

	return (
		<Modal
			opened={opened}
			onClose={() => onClose(false)}
			fullScreen={false}
			wrapChat={isCase}>
			<Modal.Header title={'nczi.verifyPatientInsurance.title'} />
			<Modal.Content>
				<NCZIPatient skipPatientIdentifier>
					<PatientInsuranceSetupVerify
						onClose={() => onClose(true)}
						patientId={patientId}
					/>
				</NCZIPatient>
			</Modal.Content>
		</Modal>
	);
};

export default PatientInsuranceSetupVerifyModal;
